import React from 'react';
import type { UserRole } from '@/types';

interface UserRoleBadgeProps {
  role: UserRole | string;
  size?: 'sm' | 'md' | 'lg';
}

const roleConfig: Record<string, { bg: string; text: string; ring: string; label: string }> = {
  ADMIN: {
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    ring: 'ring-purple-600/20',
    label: 'Admin',
  },
  BROKER: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    ring: 'ring-blue-600/20',
    label: 'Broker',
  },
  DEVELOPER: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    ring: 'ring-green-600/20',
    label: 'Developer',
  },
  FOS_AGENT: {
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    ring: 'ring-orange-600/20',
    label: 'FOS Agent',
  },
  AGENT: {
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    ring: 'ring-orange-600/20',
    label: 'Agent',
  },
  FINANCE: {
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    ring: 'ring-cyan-600/20',
    label: 'Finance',
  },
  STAFF: {
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    ring: 'ring-gray-600/20',
    label: 'Staff',
  },
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-1.5 text-sm',
};

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ role, size = 'md' }) => {
  const config = roleConfig[role] || {
    bg: 'bg-secondary-50',
    text: 'text-secondary-700',
    ring: 'ring-secondary-600/20',
    label: role,
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ring-1 ring-inset ${config.bg} ${config.text} ${config.ring} ${sizeClasses[size]}`}
    >
      <span
        className={`mr-1.5 h-1.5 w-1.5 rounded-full ${config.text.replace('text-', 'bg-').replace('-700', '-500')}`}
      />
      {config.label}
    </span>
  );
};

export default UserRoleBadge;
